<template>
  <b-tabs content-class="mt-3">
    <b-tab
      v-if="
        action.channel == 'email' ||
        action.channel == 'email/whatsapp' ||
        action.channel == 'qrcode' ||
        action.channel == 'emailsms' ||
        action.channel == 'widget' ||
        action.channel == 'link' ||
        action.channel == 'totem' ||
        action.channel == 'whatsapp' ||
        (action.channel == 'sms' && action.sms.config === 'link') ||
        action.channel == 'click-to-call'
      "
      :title="`${this.$t('newAction.stepOne.surveyLayout')}`"
      active
    >
      <template-email />
    </b-tab>
    <b-tab
      v-if="
        (action.channel == 'email' ||
          action.channel == 'emailsms' ||
          action.channel == 'widget' ||
          action.channel == 'qrcode' ||
          action.channel == 'link' ||
          action.channel == 'totem' ||
          action.channel == 'click-to-call' ||
          action.channel == 'whatsapp' ||
          (action.channel == 'sms' && action.sms.config === 'link')) &&
        action.closingMessageEnabled
      "
      :title="`${this.$t('newAction.stepOne.titleClosingMessage')}`"
    >
      <template-closing-message />
    </b-tab>
    <b-tab
      v-if="
        (action.channel == 'email' ||
          action.channel == 'emailsms') &&
        action.enableCustomTemplateEmail
      "
      :title="`Carta convite`"
    >
      <template-email-custom />
    </b-tab>
    <b-tab
      v-if="
        (action.channel == 'email' ||
          action.channel == 'emailsms' ||
          action.channel == 'widget' ||
          action.channel == 'qrcode' ||
          action.channel == 'link' ||
          action.channel == 'totem' ||
          action.channel == 'click-to-call' ||
          (action.channel == 'sms' && action.sms.config === 'link')) &&
        action.automaticAnswerEnabled
      "
      :title="`${this.$t('newAction.stepOne.titleAutomaticAnswer')}`"
    >
      <template-automatic-answer />
    </b-tab>
    <b-tab
      title="SMS"
      v-if="action.channel == 'sms' || action.channel == 'emailsms'"
    >
      <template-sms />
    </b-tab>
    <b-tab title="Widget" v-if="action.channel == 'widget'">
      <template-widget />
    </b-tab>
  </b-tabs>
</template>

<script>
import { mapState } from 'vuex';

import templateEmail from './email';
import templateSms from './sms';
import templateClosingMessage from './closingMessage';
import templateEmailCustom from './template-email-custom';
import templateAutomaticAnswer from './automatic-answer';
import templateWidget from './widget';

export default {
  name: 'Templates',

  components: {
    templateEmail,
    templateSms,
    templateClosingMessage,
    templateWidget,
    templateAutomaticAnswer,
    templateEmailCustom
  },

  computed: {
    ...mapState('actions', ['action']),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/molecules/action-templates/index.vue